import React from 'react';

const AppTools = () => {
    return (
      <div className="skills-content">
            <h3 className="skills-title">App Tools</h3>

            <div className="skills-box">
                <div className="skills-group">
                    <div className="skills-data">
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills-name">VS Code</h3>
                            <span className="skills-level">Advanced</span>
                        </div>
                    </div>

                    <div className="skills-data">
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills-name">Adobe Ilustrator</h3>
                            <span className="skills-level">Elementary</span>
                        </div>
                    </div>

                    <div className="skills-data">
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills-name">Figma</h3>
                            <span className="skills-level">Advanced</span>
                        </div>
                    </div>
                                       
                </div>

                <div className="skills-group">

                    <div className="skills-data">
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills-name">Adobe Photoshop</h3>
                            <span className="skills-level">Beginner</span>
                        </div>
                    </div>

                    <div className="skills-data">
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills-name">Canva</h3>
                            <span className="skills-level">Intermediate</span>
                        </div>
                    </div>

                     <div className="skills-data">
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills-name">Notion</h3>
                            <span className="skills-level">Intermediate</span>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default AppTools;